import React, {PureComponent} from 'react';
import Container from 'Components/structure/headersearch/subcomponents/container';

export default class HeaderSearch extends PureComponent {
    render() {
        return (
            <React.Fragment>
                <Container props={this.props}/>
            </React.Fragment>
        );
    }
}
